import React from "react";
import { Zap } from "lucide-react";

/**
 * Shared compact nutrition card: gradient box, calories prominent, then P/C/F/Fiber/Sugar grid.
 * Totals shape: { calories, proteins, carbs, fats, fiber, sugars } (numbers or string numbers).
 */
function CompactNutrientSummaryCard({ totals = {}, label }) {
  const getVal = (key) => {
    const v = totals[key];
    if (v === undefined || v === null || isNaN(v)) return 0;
    return parseFloat(v);
  };
  const calories = getVal("calories");
  const protein = getVal("proteins");
  const carbs = getVal("carbs");
  const fats = getVal("fats");
  const fiber = getVal("fiber");
  const sugar = getVal("sugars");

  return (
    <div className="flex flex-col gap-1 shrink-0">
      {label && (
        <span className="text-xs font-medium text-gray-500">{label}</span>
      )}
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-3 border border-gray-200">
        <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-300">
          <div className="flex items-center gap-2">
            <Zap className="w-4 h-4 text-orange-500" />
            <span className="text-xs font-medium text-gray-600">Calories</span>
          </div>
          <span className="text-lg font-bold text-gray-900">
            {calories.toFixed(0)} <span className="text-sm font-normal text-gray-600">kcal</span>
          </span>
        </div>
        <div className="grid grid-cols-5 gap-1.5">
          <div className="flex flex-col items-center gap-1">
            <span className="text-xs text-gray-600">Protein</span>
            <span className="text-xs font-semibold text-gray-800">{protein.toFixed(0)}g</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <span className="text-xs text-gray-600">Carbs</span>
            <span className="text-xs font-semibold text-gray-800">{carbs.toFixed(0)}g</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <span className="text-xs text-gray-600">Fats</span>
            <span className="text-xs font-semibold text-gray-800">{fats.toFixed(0)}g</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <span className="text-xs text-gray-600">Fiber</span>
            <span className="text-xs font-semibold text-gray-800">{fiber.toFixed(0)}g</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <span className="text-xs text-gray-600">Sugar</span>
            <span className="text-xs font-semibold text-gray-800">{sugar.toFixed(0)}g</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(CompactNutrientSummaryCard);
